import { useNormalizedPixels } from '../../../../../hooks/useResize';
import { getScaleSize } from '../../../../../utils/utils';

interface BrandLogoProps {
  scale: number;
  src: string;
}

const BrandLogo = ({ src, scale }: BrandLogoProps) => {
  const { normalizePixels } = useNormalizedPixels();
  return (
    <div
      style={{
        width: '24%',
        height: getScaleSize(normalizePixels(60, 'height'), scale),
        marginBottom: getScaleSize(normalizePixels(15, 'height'), scale),
      }}
    >
      <img src={src} alt="Brand logo" style={{ objectFit: 'contain', height: '100%' }} />
    </div>
  );
};

export default BrandLogo;
